module.exports = __webpack_public_path__ + "img/banner-8.2efb3d65.jpg";